import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantUserSkillMatchSerializerType = {
  queries: string[];
  threshold: number;
};

export type PostTenantUserSkillMatchesPayloadType = (
  Pick<TenantUserSkillMatchSerializerType, 'queries'>
);

export const apiFetchTenantUserSkillMatches = async ({
  domain = useTenantStore().domain,
  tenantUserId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostTenantUserSkillMatchesPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.tenantUserSkillMatches({ domain, tenantUserId }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
